import React from 'react'
import { connect } from 'react-redux'

import DotsBannerSection from '../components/DotsBannerSection'
import { JOBS_URL } from '../../config/'
import Button from '../components/Button'
import Icon from '../components/Icon'
import VideoPlayer from '../components/VideoPlayer'
import Place from '../components/Place'
import PageHeader from '../components/PageHeader'
import PageSection from '../components/PageSection'
import SnipstersCarousel from '../components/SnipstersCarousel'

import { showModal } from '../../reducers/modal'

const CULTURE_FEATURES = [
  { icon: 'closed_eye', caption: 'Privacy matters' },
  { icon: 'end-user', caption: 'Make it work for end-users' },
  { icon: 'shapes', caption: 'Strength in diversity' },
  { icon: 'baby', caption: 'Parents are welcome' },
  { icon: 'heart', caption: 'Good heart = Good team' },
  { icon: 'rocket--circled', caption: 'Work with passion and purpose' }
]

function ImageGallery ({ images, showModal }) {
  return (
    <div className='about-page__gallery-section__grid-container col-11 sm-col-10 md-col-9 lg-col-7 mx-auto pt2'>
      {images &&
        images.map(({ imageUrl }, idx) => {
          return (
            <Button
              className='button button--plain flex justify-center about-page__gallery-section__image'
              onClick={() => {
                showModal(
                  <div className='center'>
                    <img
                      className='about-page__gallery-section__lightbox___image'
                      src={imageUrl}
                    />
                  </div>,
                  'about-page'
                )
              }}
            >
              <img key={idx} src={imageUrl} />
            </Button>
          )
        })}
    </div>
  )
}

export const AboutPage = ({
  showModal,
  data: {
    acf: {
      headerTitle,
      headerSubtitleCopy,
      headerImages,

      introContent,

      cultureSectionTitle,

      imagesGrid,

      snipstersSlides,

      snipsBannerSectionTitle,
      snipsBannerSectionContent,
      snipstersSectionTitle,
      places
    }
  }
}) => {
  return (
    <main className='about-page main maxw-xxlarge mx-auto px2'>
      <PageHeader extraClass='about-page__page-header' title={headerTitle}>
        <div className='about-page__page-header__subtitle strong mb4 mx-auto'>
          {headerSubtitleCopy}
        </div>
        <img
          src='/static/images/about/devices.svg'
          alt='AI in radio, lamp, laptop, speaker, smartphone and microphone'
        />
      </PageHeader>

      <PageSection extraClass='about-page__intro page-section--tiny bg-white text-para mx-auto'>
        <div className='about-page__intro__body col-10 mx-auto'>
          <div
            className='text-para maxw-text mb3 mx-auto'
            dangerouslySetInnerHTML={{ __html: introContent }}
          />
        </div>
      </PageSection>
      <PageSection extraClass='about-page__video-section'>
        <div className='about-page__video-section__wrapper mx-auto'>
          <VideoPlayer
            videoClassName='about-page__video-section__video overflow-hidden'
            poster='/static/images/snips-brand-video-cover.jpg'
            preload='metadata'
            muted={false}
            loop={false}
            iframe
            src='https://www.youtube.com/embed/N3588u6z9LE'
          />
        </div>
      </PageSection>

      <PageSection extraClass='page-section--small about-page__culture-section mx-auto bg-white center'>
        <div className='about-page__culture-section__body col-10 md-col-8 lg-col-6 mx-auto mb4'>
          {cultureSectionTitle && (
            <h2 className='h2 mb4'>{cultureSectionTitle}</h2>
          )}
          <div className='about-page__culture-features flex flex-wrap'>
            {CULTURE_FEATURES.map(({ icon, caption }, idx) => (
              <figure
                key={idx}
                className='about-page__culture-features-item flex flex-column items-center mb3'
              >
                <Icon icon={icon} />
                <figcaption className='about-page__culture-features-item__caption small strong center'>
                  {caption}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </PageSection>

      <PageSection extraClass='page-section--tiny about-page__gallery-section center'>
        <ImageGallery images={imagesGrid} showModal={showModal} />
      </PageSection>

      <PageSection extraClass='about-page__snipsters-section mx-auto bg-primary center'>
        {snipstersSectionTitle && (
          <h2 className='about-page__snipsters-section__title h2 mb2 white'>
            {snipstersSectionTitle}
          </h2>
        )}
        <div className='sm-col-11 md-col-9 mx-auto'>
          <SnipstersCarousel slides={snipstersSlides} />
        </div>
      </PageSection>

      <DotsBannerSection
        title={snipsBannerSectionTitle}
        extraContent={
          <div className='bg-primary center'>
            <Button
              className='about-page__jobs-btn button'
              href={JOBS_URL}
              target='_blank'
            >
              Join our team!
            </Button>
          </div>
        }
      />

      <PageSection extraClass='about-page__offices-section bg-white'>
        <div className='center'>
          <h2 className='h2 mb3'>Come say hi!</h2>
        </div>
        <div className='about-page__offices-section__places overflow-hidden flex flex-wrap justify-center mx-auto'>
          {places &&
            places.map((place, index) => <Place key={index} {...place} />)}
        </div>
      </PageSection>
    </main>
  )
}

export default connect(null, { showModal })(AboutPage)



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/AboutPage.js